import React from 'react'
import { Dialog, DialogContent, DialogContentText, LinearProgress } from '@mui/material'
import useStyles from './styles'

function LoadingPage(props) {
    const classes = useStyles()

    return (
        <Dialog
            fullWidth
            maxWidth={"xs"}
            open={props.loadingPage} >
            <DialogContent>
                <DialogContentText className={classes.dialogContentText}>
                    لطفا صبر کنید ...
                </DialogContentText>
                <LinearProgress color="primary" className={classes.linearProgress} />
            </DialogContent>
        </Dialog>
    )
}

export default LoadingPage

